app.controller('Gallery', function ($scope) {
	$scope.gallItems = {};
});